var exports = {
  "zb": "expand-button-line__i06Y9x",
  "S8": "expand-up-and-down__t560d5",
  "DQ": "expand-button-unified__vVultF",
};

module.exports = exports;
